module.exports = __webpack_public_path__ + "static/media/2.031c56c8.png";